export {
  Countdown,
  type CountdownProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Countdown';
